import { Locale, LOCALES } from './lingui.constants';

const LOCALE_SET: ReadonlySet<string> = new Set(LOCALES);

export const DEFAULT_LOCALE = Locale.EnUs;

export function isLocale(value: string): value is Locale {
  return LOCALE_SET.has(value);
}

// Coerce an external locale string (API, native `en_US`, URL params) to lowercase BCP-47, or undefined if unsupported.
export function normalizeLocale(value: string | null | undefined): Locale | undefined {
  if (!value) return undefined;
  const candidate = value.replace(/_/g, '-').toLowerCase();
  return isLocale(candidate) ? candidate : undefined;
}
